import React, { useEffect } from 'react';

const WorkOrderStep8Costs = ({ formData, setFormData, formErrors }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Auto-calculate total cost
  useEffect(() => {
    const labor = parseFloat(formData.laborCost) || 0;
    const parts = parseFloat(formData.partsCost) || 0;
    const other = parseFloat(formData.otherCost) || 0;
    const total = labor + parts + other;

    if (formData.totalCost !== total.toFixed(2)) {
      setFormData(prev => ({
        ...prev,
        totalCost: total.toFixed(2)
      }));
    }
  }, [formData.laborCost, formData.partsCost, formData.otherCost, formData.totalCost, setFormData]);

  return (
    <div className="step-form">
      <div className="form-section">
        <h3 className="section-title">Costs Section</h3>
        <div className="row">
          <div className="form-group col-md-3">
            <label htmlFor="laborHours">Labor Hours</label>
            <input
              type="number"
              id="laborHours"
              name="laborHours"
              value={formData.laborHours}
              onChange={handleChange}
              step="0.1"
              min="0"
            />
          </div>
          <div className="form-group col-md-3">
            <label htmlFor="laborCost">Labor Cost (₹)</label>
            <input
              type="number"
              id="laborCost"
              name="laborCost"
              value={formData.laborCost}
              onChange={handleChange}
              step="0.01"
              min="0"
            />
          </div>
          <div className="form-group col-md-3">
            <label htmlFor="partsCost">Spare Parts Cost (₹)</label>
            <input
              type="number"
              id="partsCost"
              name="partsCost"
              value={formData.partsCost}
              onChange={handleChange}
              step="0.01"
              min="0"
            />
          </div>
          <div className="form-group col-md-3">
            <label htmlFor="otherCost">Other Charges (₹)</label>
            <input
              type="number"
              id="otherCost"
              name="otherCost"
              value={formData.otherCost}
              onChange={handleChange}
              step="0.01"
              min="0"
            />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="totalCost">Total Work Order Cost (₹)</label>
          <input
            type="text"
            id="totalCost"
            name="totalCost"
            value={formData.totalCost || '0.00'}
            readOnly
            className="readonly"
            style={{ fontWeight: '600', fontSize: '1.1rem', color: 'var(--primary-color)' }}
          />
          <small style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>
            Automatically calculated from Labor, Parts, and Other costs
          </small>
        </div>
      </div>
    </div>
  );
};

export default WorkOrderStep8Costs;

